module.exports = __webpack_public_path__ + "static/flare-4.56b779e9.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/flare-4.png
// module id = 211
// module chunks = 0 1 22